// src/App.jsx
import React, { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import Navigation from './components/Navigation';
import { checkAuthStatus, fetchAccess } from './store/thunks/authThunks';

function App() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
  const authChecked = useSelector((state) => state.auth?.authChecked);
  const accessChecked = useSelector((state) => state.auth?.accessChecked);
  const accessLoading = useSelector((state) => state.auth?.accessLoading);
  const access = useSelector((state) => state.auth?.access);

  const authInFlightRef = useRef(false);
  const accessInFlightRef = useRef(false);

  // 🆕 Шаг 1: проверить сессию Kratos при старте
  useEffect(() => {
    if (authChecked) return;
    if (authInFlightRef.current) return;

    const token = localStorage.getItem('kratos_session_token');
    if (!token) {
      // Нет токена — не аутентифицирован, но помечаем checked
      console.log('🎭 App: no token — skipping checkAuthStatus');
      dispatch({ type: 'auth/checkStatus/rejected', payload: null });
      return;
    }

    console.log('🎭 App: checking auth status');
    authInFlightRef.current = true;
    dispatch(checkAuthStatus()).finally(() => {
      authInFlightRef.current = false;
    });
  }, [authChecked, dispatch]);

  // 🆕 Шаг 2: загрузить access после auth
  useEffect(() => {
    if (!isAuthenticated || !authChecked) return;
    if (access && accessChecked) return;
    if (accessLoading || accessInFlightRef.current) return;

    console.log('🎭 App: fetching access profile');
    accessInFlightRef.current = true;
    dispatch(fetchAccess()).finally(() => {
      accessInFlightRef.current = false;
    });
  }, [isAuthenticated, authChecked, accessChecked, accessLoading, access, dispatch]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navigation />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default App;
